import classNames from "classnames";
import { isNil } from "lodash-es";
import React from "react";

import { IWithTabContextProps, withTabsContext } from "./Tabs";

export interface ITabPanelsProps extends IWithTabContextProps {
  className?: string;
  children: React.ReactNode[];
  unmountOnExit?: boolean;
}

export class TabPanelsComponent extends React.PureComponent<ITabPanelsProps> {
  render() {
    let { children } = this.props;
    const { className, unmountOnExit = true } = this.props;

    const classes = classNames("el-tab-panel", className);

    const mounted = () => {
      children = React.Children.map(children, (child: any, index: number) => {
        const props = this.props.activeIndex !== index ? { style: { display: "none" } } : {};
        return React.cloneElement(child, props);
      });

      return children;
    };

    if (isNil(this.props.activeIndex)) {
      return <div className={classes} />;
    }

    return (
      <div className={classes}>
        {unmountOnExit && children[this.props.activeIndex]}
        {!unmountOnExit && mounted()}
      </div>
    );
  }
}

export const TabPanels = withTabsContext(TabPanelsComponent);
